import React, { useState, useEffect } from "react";
import MaterialTable, { MTableHeader, MTableBody } from "material-table";
import { History } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import useAPI from "../../../hooks/useAPI";
import { dateRenderer } from "../../../services/formatSvc";
import {
  localization,
  modifyDefaultOptions,
  tableIconsModified,
  arrayToLookup,
  styledHeaderSticky,
} from "../../../helpers/table";
import FilterMultiSelect from "../../../components/table/FilterMultiSelect";
import moment from "moment";
import HistoryModal from "./HistoryModal";
import Delete from "@material-ui/icons/Delete";
import ConfirmModal from "../../../components/common/ConfirmModal";
import {deleteFixedPcs} from "../../../requests/exportRequests";
import useToast from "../../../hooks/useToast";
import LoadingTable from '../../../components/table/LoadingTable';

const dateNow = moment();

export default function AdminUnifiedTable({ inactives }) {
  const history = useHistory();
  const api = useAPI();
  const toast = useToast()
  const [modal, setModal] = useState(null);
  const [data, setData] = useState([]);
  const [types, setTypes] = useState([]);
  const [deleteModal,setDeleteModal]= useState({show:false,value:null})
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(async () => {
    await getData();
    setIsLoaded(true)
  }, []);

  const getData = async () => {
    try {
      const result = await api.get("/mng/fixedPcs");
      const types = await api.get("/mng/proj/types");
      setData(result.map((e) => ({ ...e, requiredString: e.required ? "Да" : "Нет" })));
      setTypes(types);
    } catch (error) {
      console.log(error);
    }
  };

  const deletePcs = async (id) => {
    deleteFixedPcs(api,toast,id).then(()=>setDeleteModal({show: false,value: null})).then(async ()=> await getData())
  }

  const columns = [
    {
      title: "№",
      field: "index",
      filtering: false,
      minWidth: "50px",
      maxWidth: "60px",
    },
    {
      title: "Наименование показателя",
      field: "name",
      minWidth: "300px",
      maxWidth: "340px",
      lookup: arrayToLookup("name", data),
      filterComponent: FilterMultiSelect,
      customFilterAndSearch: (term, rowData) => {
        if (term.length == 0) return true;
        const res = term.filter((x) => rowData.name.includes(x));
        return res.length > 0;
      },
      render: (rowData) => (
        <span
          onClick={() => history.push(`/admin/indexes/${rowData.id}`)}
          style={{ cursor: "pointer", color: "#0D6EFD" }}
        >
          {rowData.name}
        </span>
      ),
    },
    { 
      title: "Единицы измерения",
      field: "unit",
      filtering: false,
      minWidth:'100px',
      maxWidth:'100px',
    },
    { 
      title: "Методика расчета показателя",
      field: "calcDescr",
      filtering: false,
      minWidth: "360px",
      maxWidth: "550px",
    },
    {
      title: "Тип проекта",
      field: "projTypes",
      minWidth:'150px',
      maxWidth:'160px',
      lookup: arrayToLookup("name", types),
      filterComponent: FilterMultiSelect,
      customFilterAndSearch: (term, rowData) => {
        if (term.length == 0) return true;
        const res = term.filter((x) => rowData.projTypes.map((e) => e.name).includes(x));
        return res.length > 0;
      },
      render: (rowData) => (
        <div>
          {rowData.projTypes.map((e, i) => (
            <div key={i}>{e.name}</div>
          ))}
        </div>
      ),
    },
    {
      title: "Дата начала",
      minWidth:'135px',
      maxWidth:'145px',
      field: "startDate",
      filtering: false,
      render: (rowData) => <>{dateRenderer(rowData.startDate)}</>,
    },
    {
      title: "Дата окончания",
      minWidth:'135px',
      maxWidth:'145px',
      field: "endDate",
      filtering: false,
      render: (rowData) => <>{dateRenderer(rowData.endDate)}</>,
    },
  ];

  return (
    <div>
      <LoadingTable loadingObject={{isLoaded}}>
      <MaterialTable
        title=""
        components={{
          Container: (props) => <div className="special-filter-without-max" {...props} />,
          Body: (props) => (
            <>
              <MTableBody {...props} />
              <div id="portal-root"></div>
            </>
          ),
          Header: (props) => <MTableHeader {...props} tableHeadStyle={styledHeaderSticky} />,
        }}
        options={modifyDefaultOptions({
          toolbar: false,
          maxBodyHeight: "85vh",
          filterCellStyle: {
            position: "sticky",
            top: 35,
            background: "white",
          },
        })}
        actions={[
          (rowData) => ({
            custom: true,
            icon: () => <History style={{ color: "#0D6EFD" }} />,
            tooltip: "История версий",
            onClick: () => {
              setModal(rowData.id);
            },
          }),
          (rowData) => ({
            icon: (() => <Delete style={{ color:  "#dc3545" }} />),
            tooltip: 'Удалить',
            onClick: (_, row) => setDeleteModal({show: true, value: row?.id}),
          }),
        ]}
        icons={tableIconsModified}
        localization={localization}
        columns={columns}
        data={
          inactives
            ? data.map((e, i) => ({ ...e, index: i + 1 }))
            : data
                .filter((e) => moment(e.endDate).add(1, "d") >= moment(dateNow) || !e.endDate)
                .map((e, i) => ({ ...e, index: i + 1 }))
        }
      />
      </LoadingTable>
      {modal && <HistoryModal index={modal} onClose={() => setModal(null)} />}
      {<ConfirmModal 
        show={deleteModal.show}
        headerText={'Подтверждение операции'}
        onConfirm={()=> deletePcs(deleteModal.value)}
        onClose={()=>setDeleteModal({show: false,value: null})}
        message={'Данный показатель будет удален. Вы уверены?'}
      />}
    </div>
  );
}
